<template>
  <div v-if="body_show" style="padding-bottom: 55px">
    <public-header :colors="'#fff'" :headimg="data.userdetail.headimgurl" :routArg="routArg"></public-header>
    <div class="course_listnew">
      <ul>
        <li v-for="(item,index) in course_list" :key="index" class="clearfix">
          <h2>
            <img src="@a/donestatus0.png" alt="" v-if="item.donestatus==0"/>
            <img src="@a/donestatus1.png" alt="" v-else-if="item.donestatus==1"/>
            <span v-else-if="item.donestatus==2"></span>
            {{item.starttime}} - {{item.latest_time}}
          </h2>
          <span class="line"></span>
          <div class="list_r">
            <h1 class="text-ellipsis">{{item.name}}</h1>
            <!-- <p>已有{{item.count}}人完成</p> -->
            <a v-if="item.donestatus==2" style="background-color:#ccc">待解锁</a>
            <a @click="to_details(item.cid,item.cpid)" v-else>进入项目</a>
          </div>
        </li>
      </ul>
    </div>
    <router-link v-if="data.alldoned == 1" :to="'/person_report_new?cid=' + cid" class="course_href course_hrefs">
      <p>我的报告</p>
    </router-link>
    <a v-else class="course_href">
      <p>我的报告</p>
    </a>
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img src="@a/vpo_v.png" />
        <h3>报名后进入小组学习全部项目</h3>
        <div class="href_v" @click="signHandle">立即报名</div>
      </div>
    </van-popup>
    <!-- 公用音频底部 -->
    <public-foot-audio :footerShow="footer_show"></public-foot-audio>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <!-- 未关注弹窗 -->
    <van-popup :close-on-click-overlay="false" v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">{{data.userdetail.name}}你好！您已成功报名{{data.courseName}}，为了不和组织失联，请关注下方二维码。</h3>
        <h4>识别或扫描二维码</h4>
        <img src="@a/carrer.png" />
        <h4>已关注的看官自动忽略</h4>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getproject,
  coursedetail
} from "@/api/course";
import {
  project_click_time
} from "@/api/course"
import {
  statistics
} from "@/api/public";
import {
  statistic_next
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
import {
  getStorage,
  setStorage
} from "@/utils/tools"

export default {
  props: {
    pulldata: Object
  },
  data() {
    return {
      cid: null,
      data: {},
      body_show: false,
      course_list: [],
      click_cpid: "",
      assistant_show: false,
      phone: null,
      source: '',
      pdk: '',
      aspx: '',
      footer_show: true,
      routArg: {},
      assistant_show: false
    }
  },
  methods: {
    pullData(data) {
      let querys = this.$route.query;
      this.cid = querys.cid;
      this.pdk = querys.pdk;
      this.aspx = querys.aspx;
      this.body_show = true;
      this.data = data;
      // 判断是否关注
      // if (!data.subscribe) {
      //   this.assistant_show = true;
      // }
      this.course_list = data.projects;
      if (querys.source) {
        this.routArg['source'] = querys.source;
      }
      if (querys.pdk) {
        this.routArg['pdk'] = querys.pdk;
      }
      if (querys.aspx) {
        this.routArg['aspx'] = querys.aspx;
      }
    },
    to_details(cid_, cpid_, index) {
      let showModul = index == 3 ? 'true' : 'false';
      //判断是否是试听
      if (this.data.project_type == 1) {
        project_click_time({
            cid: cid_,
            cpid: cpid_
          })
          .then((data) => {
            this.$router.push({
              path: '/project_details',
              query: {
                'cid': cid_,
                'cpid': cpid_,
                'pdk': this.routArg.pdk,
                'aspx': this.routArg.aspx,
                'source': this.routArg.source,
                'showModul': showModul
              }
            });
          });
      } else {
        this.$router.push({
          path: '/project_details',
          query: {
            'cid': cid_,
            'cpid': cpid_,
            'pdk': this.routArg.pdk,
            'aspx': this.routArg.aspx,
            'source': this.routArg.source,
            'showModul': showModul
          }
        });
      }

    },
    to_tost: function(cid_, cpid_, toggle_) {
      var self = this;
      if (self.data.project_type == 1) {
        if (toggle_ == 0) {
          project_click_time({
              cid: cid_,
              cpid: cpid_
            })
            .then((data) => {
              this.click_cpid = cpid_;
              this.assistant_show = true;
            });
        } else {
          this.assistant_show = false;
        }
      }

    },
    // 立即报名
    signHandle() {
      this.statistical("coursebtn");
      // sensors.track('clickToEnroll', {
      //   campaignName: this.source || '',
      //   courseID: this.cid,
      //   courseName: '个人战略商业价值重塑'
      // })
      sensors.track('applyCourse', {
        classification: this.data.bigcoursename,
        classification_id: this.$route.query.bid,
        course_id: this.cid,
        course_name: this.data.coursename,
        course_discount_price: this.data.courseprice,
        course_original_price: this.data.originalprice,
        course_starttime: this.data.begintime,
        apply_page_url: location.href,
        apply_page_title: this.data.bigcoursename
      });
      // 神策统计--点击立即报名按钮
      let godPolicy = getStorage('godPolicy', 'godPolicy');
      let bool = true;
      if (!godPolicy || godPolicy.length == 0) {
        bool = false;
        coursedetail({ // 因为目前只有一个，当前页面也没有bid所以暂时写死
            bid: 1
          })
          .then((data) => {
            godPolicy = data;
            // 把神策数据存到本地缓存
            let go = {
              course_id: this.cid,
              classification: data.bigcoursename,
              course_name: data.coursename,
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime
            };
            setStorage('godPolicy', 'godPolicy', go);
            this.godPolicyHandle(false, godPolicy);
          })
      } else {
        this.godPolicyHandle(true, godPolicy);
      }


      if (this.data.mobilestatus) {
        // 是否需要验证验证码
        this.$refs.handle.need_verify = this.data.need_verify || false;
        // 判断用户手机号是否已验证
        this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
        this.$refs.handle.show = true;

      } else {
        this.$refs.handle.pay()
      }
    },
    // 立即报名神策方法
    godPolicyHandle(bool, godPolicy) {
      // 判断缓存是否有数据，如果没有请求数据
      sensors.track('applyCourse', {
        apply_page_url: location.href,
        apply_page_title: '个人战略—商业价值重塑课-项目列表',
        classification: bool ? godPolicy.classification : godPolicy.bigcoursename,
        classification_id: 1, //bid
        course_id: this.$route.query.cid,
        course_name: bool ? godPolicy.course_name : godPolicy.coursename,
        course_discount_price: bool ? godPolicy.course_discount_price : godPolicy.courseprice,
        course_original_price: bool ? godPolicy.course_original_price : godPolicy.originalprice,
        course_starttime: bool ? godPolicy.course_starttime : godPolicy.begintime
      });
    },
    // 本地统计
    statistical(data) {
      statistics({
        type: data
      }).then();
    },
    statistic_() {
      statistic_next({
          cid: this.cid
        })
        .then();
    },
    onScroll() {
      window.onscroll = (ev) => {
        let t = document.documentElement.scrollTop || document.body.scrollTop;
        let w = 10;
        if (t > w) {
          this.footer_show = false;
        } else {
          this.footer_show = true;
        }
      }
    }
  },
  created() {
    this.pullData(this.pulldata);
    shareCon("course", this);
  },
  mounted() {
    this.onScroll()
  }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.course_listnew {
  width: 100%;
  height: auto;
  ul {
    li {
      width: 100%;
      padding: 30px;
      padding-left: 40px;
      padding-bottom: 0;
      text-align: left;
      position: relative;
      h2 {
        color: #333;
        font-size: 24px;
        line-height: 24px;
        img {
          width: 24px;
          margin-right: 6px;
        }
        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          background-color: #ccc;
          margin-right: 6px;
          border-radius: 50%;
        }
      }
      span.line {
        position: absolute;
        left: 52px;
        top: 50px;
        width: 2px;
        background-color: #ccc;
        height: 100%;
        z-index: -1;
      }
      .list_r {
        float: right;
        width: 650px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 11px 5px 0px rgba(51, 51, 51, 0.1);
        border-radius: 12px;
        margin-top: 10px;
        padding: 55px 32px;
        position: relative;
        h1 {
          color: #333;
          font-size: 34px;
          line-height: 50px;
          width: 440px;
          font-weight: bold;
        }
        p {
          color: #666;
          font-size: 24px;
          line-height: 34px;
        }
        a {
          position: absolute;
          width: 150px;
          line-height: 54px;
          background: rgba(234, 52, 92, 1);
          border-radius: 27px;
          color: #fff;
          text-align: center;
          font-size: 26px;
          right: 32px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    li:last-child {
      span.line {
        height: 210px;
      }
    }
  }
}

.course_href {
  display: block;
  margin: 0 auto;
  width:690px;
  line-height:80px;
  border-radius:8px;
  text-align: center;
  margin-top: 70px;
  background: #CCCCCC;
  color: #fff;
  font-size: 34px;
}

.course_hrefs {
  background-color: #EA345C;
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 100px 60px 100px;
    img {
      width: 430px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
    }
    .href_v {
      display: block;
      width: changeRem(7.7) + px;
      line-height: changeRem(1.6) + px;
      text-align: center;
      background-color: #EB5032;
      margin: 0 auto;
      font-size: changeRem(.68) + px;
      color: #FFFFFF;
      -webkit-border-radius: changeRem(.16) + px;
      border-radius: changeRem(.16) + px;
      margin-top: 100px
    }
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
</style>
